// extracted by mini-css-extract-plugin
export default {"root":"IconReviewStar_root__uFxq6","filled":"IconReviewStar_filled__r98rf"};